import { UiWebinarLinkModel } from "../../models";

export function mockUiWebinarLinkModel({
    id = "webinar-link-1234",
    type = "uiWebinarLink",
    locale = "en",
    content = mockUiWebinarLinkModelContent()
}: Partial<UiWebinarLinkModel> = {}): UiWebinarLinkModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiWebinarLinkModelContent = UiWebinarLinkModel["content"];

export function mockUiWebinarLinkModelContent({
    entryTitle = "Example webinar link",
    title = "Lorem ipsum dolor sit amet",
    url = "/foo/bar",
    ...optionals
}: Partial<UiWebinarLinkModelContent> = {}): UiWebinarLinkModelContent {
    return {
        entryTitle,
        title,
        url,
        ...optionals
    };
}
